<template>
    <div class="StarCounter">
        <StreamlineIcon
            v-for="star in 5"
            :key="'star-'+star"
            :icon="starIcon"
            class="StarCounter__star"
            :stroke="strokeColor"
            :fill="fillColor(star)"
            :size="16"
        />
        <div
            v-if="showCountBadge"
            :class="badgeClass"
        >
            {{ rating }} of 5
        </div>
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {RatingStar} from "@reviewpush/streamline-regular/lib/social-medias-rewards-rating/Rating";
import stat from 'status/index';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'RPStarCounter',
    components: {
        StreamlineIcon
    },
    props: {
        rating: {
            type: Number,
            required: true,
        },
        showCountBadge: {
            type: Boolean,
            default: true,
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
    computed: {
        starIcon(){
            return RatingStar;
        },
        badgeClass(){
            return statusBuilder('StarCounter__badge', this.status);
        },
        strokeColor(){
            switch(this.status){
            case stat.SUCCESS:
                return '#60CD55';
            case stat.WARNING:
                return '#F9C829';
            default:
                return '#FE4027';
            }
        }
    },
    methods: {
        fillColor(i){
            return i <= this.rating ? this.strokeColor : 'transparent';
        }
    }
};
</script>
<style lang="scss">
    .StarCounter {
        display: flex;
        align-content: center;
        white-space: nowrap;
        &__star{
            margin-right: 0.25rem;
        }
        &__badge{
            color: $grey-800;
            font-size: 0.7rem;
            border-radius: 4px;
            line-height: 1rem;
            text-align: center;
            padding: 0 0.25rem;
            &--success{
                background: $gradient-positive;
            }
            &--warning{
                background: $warning-yellow;
            }
            &--error{
                background: $error-red;
            }
        }
    }
</style>

<docs>
```vue
import stat from 'status/index';

<RPStarCounter :rating="3" />
<br>
<RPStarCounter :rating="1" :show-count-badge="false" />
<br>
<RPStarCounter :rating="5" :show-count-badge="false" :status="stat.SUCCESS"/>
```
</docs>
